import q from "../styles/components/examQuestion.module.scss";
import QuestionContent from "./QuestionContent";

const DescriptiveQuestion = ({ id, quNo, audioURL, imageURL, question, score, body }) => (
    <article className={q.card} key={id}>
        <header className={q.header}>
            <p className={q.number}>{`سوال ${quNo}`}</p>
            <p className={q.score}>{`${score} نمره`}</p>
        </header>
        <QuestionContent
            body={body}
            imageURL={imageURL}
            audioURL={audioURL}
            question={question}
            id={id}
        />
    </article>
);

export default DescriptiveQuestion;
